import React, { useEffect, Fragment, useState } from "react";
import Grid from "@material-ui/core/Grid";
import moment from "moment";
import instance from "../utils/services/services";
import { makeStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import DateFnsUtils from "@date-io/date-fns";
import Button from "@material-ui/core/Button";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
  TimePicker
} from "@material-ui/pickers";
import "date-fns";
import { createMuiTheme, ThemeProvider } from "@material-ui/core";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import Container from '@material-ui/core/Container';
import green from '@material-ui/core/colors/green';
import { Checkbox } from "primereact/checkbox";

const materialTheme = createMuiTheme({
  overrides: {
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: "#33a5db"
      }
    },
    PrivateNotchedOutline: {
      legendNotched: {
        paddingRight: '20px'
      }
    },
    MuiPickersCalendarHeader: {
      switchHeader: {}
    },
    MuiPickersDay: {
      day: {},
      daySelected: {
        backgroundColor: "#33a5db"
      },
      dayDisabled: {},
      current: {}
    },
    MuiPickersModal: {
      dialogAction: {}
    },
    MuiOutlinedInput: {
      input: {
        paddingTop: 11,
        paddingBottom: 11
      }
    }
  }
});

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}));

const GenericDashboard = (props) => {
  const classes = useStyles();
  const [dateData, setDateData] = useState(false);
  const [currentDate, setCurrentDate] = React.useState(moment().utcOffset(0).format('MM-DD-YYYY'));
  const [dashboardData, setDashboardData] = React.useState(null);
  const [selectedExportCards, setSelectedExportCards] = React.useState([]);
  const [exportAll, setExportAll] = React.useState(false);

  const getTeamDetail = () => {
    instance
      .get(`Dashboard/GenericDashboard?date=${currentDate}`)
      .then(response => {
        if (response.data.status) {
          setDashboardData(response.data.data)
        }
      })
      .catch(error => {
        // console.log(error);
      });
  };

  const changeDateData = (dateData) => {
    let newDate = !dateData;
    setDateData(newDate)
    setCurrentDate(moment(new Date(dateData)).format('MM-DD-YYYY'))
  }

  useEffect(() => {
    getTeamDetail()
  }, [currentDate])

  const exportCardData = (csvData) => {
    let fileName =
      "team_export_" +
      moment(new Date(), "ddd DD-MMM-YYYY, hh:mm A")
        .format("MM_DD_YYYY");
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

    const fileExtension = ".xlsx";
    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
    toast.success(
      `File exported successfully. Found the ${csvData.length} records`
    );
  }

  const exportCard = (dashboardData) => {
    if (dashboardData && dashboardData.providers && dashboardData.providers.length > 0) {
      let newDashboardArray = [];

      dashboardData.providers.forEach((provider, ix) => {
        let row = {
          "DEPARTMENT NAME": dashboardData.departmentName,
          "TEAM NAME": provider.teamName,
          "PROVIDER NAME": provider.providerName,
          "SHIFT DATE": provider.shiftDate ? moment(
            new Date(provider.shiftDate.split("T")[0])
          ).utcOffset(0).format("MM-DD-YYYY") : '',
          "START TIME": provider.startTime,
          "END TIME": provider.endTime,
          "ON-CALL": provider.onCall == true ? 'TRUE' : 'FALSE',
          "PREFERRED CALL NUMBER": provider.preferredCallNumber ? provider.preferredCallNumber : "N/A"
        };
        newDashboardArray.push(row);
      });
      exportCardData(newDashboardArray)
    } else {
      toast.error(
        "Records not found"
      );
    }
  }

  const onClickExportAll = (dashboardData) => {
    if (dashboardData && dashboardData.length > 0 && exportAll) {
      let newDashboardArray = [];
      dashboardData.forEach((dashboard, i) => {
        dashboard.providers && dashboard.providers.length > 0 && dashboard.providers.forEach((provider, ix) => {
          let row = {
            "DEPARTMENT NAME": dashboard.departmentName,
            "TEAM NAME": provider.teamName,
            "PROVIDER NAME": provider.providerName,
            "SHIFT DATE": provider.shiftDate ? moment(
              new Date(provider.shiftDate.split("T")[0])
            ).utcOffset(0).format("MM-DD-YYYY") : '',
            "START TIME": provider.startTime,
            "END TIME": provider.endTime,
            "ON-CALL": provider.onCall == true ? 'TRUE' : 'FALSE',
            "PREFERRED CALL NUMBER": provider.preferredCallNumber ? provider.preferredCallNumber : "N/A"
          };
          newDashboardArray.push(row);
        });
      });
      exportCardData(newDashboardArray)
    } else if(selectedExportCards && selectedExportCards.length > 0 && !exportAll) {
      let newDashboardArray = [];
      dashboardData.filter(dash => selectedExportCards.includes(dash.departmentCode)).forEach((dashboard, i) => {
        dashboard.providers && dashboard.providers.length > 0 && dashboard.providers.forEach((provider, ix) => {
          let row = {
            "DEPARTMENT NAME": dashboard.departmentName,
            "TEAM NAME": provider.teamName,
            "PROVIDER NAME": provider.providerName,
            "SHIFT DATE": provider.shiftDate ? moment(
              new Date(provider.shiftDate.split("T")[0])
            ).utcOffset(0).format("MM-DD-YYYY") : '',
            "START TIME": provider.startTime,
            "END TIME": provider.endTime,
            "ON-CALL": provider.onCall == true ? 'TRUE' : 'FALSE',
            "PREFERRED CALL NUMBER": provider.preferredCallNumber ? provider.preferredCallNumber : "N/A"
          };
          newDashboardArray.push(row);
        });
      });
      exportCardData(newDashboardArray)
    } else {
      toast.error(
        "Records not found"
      );
    }
  }

  const handleCardCheckChange = (departmentCode) => {
    let selectedExportCardsArray = selectedExportCards;
    if(selectedExportCards && selectedExportCards.indexOf(departmentCode) > -1) {
      selectedExportCardsArray.splice(selectedExportCards.indexOf(departmentCode), 1);
    } else {
      selectedExportCardsArray.push(departmentCode)
    }
    setSelectedExportCards((selectedExportCards)=> {
      return [...selectedExportCardsArray]
    })
  }
  
  useEffect(() => {
    setSelectedExportCards(selectedExportCards)
  }, [selectedExportCards.length])

  useEffect(() => {
    const bgImage = require('../backg.png');
    document.body.style.backgroundImage = `url(${bgImage})`;
    getTeamDetail()
  }, [])

  let isFound = false
 
  return (
    <Fragment>
      <div className={classes.root}>
        <Grid className="generic-dashboard-container" container>
          <Grid item xs={12}>
            <div className="dashboard-left-bar">
              <Icon style={{ marginLeft: "10px", paddingTop: "2px", marginRight: "10px", textAlign: "center", justifyContent: "center" }} spacing={4} className="fa fa-chevron-left" color="primary" />
              <span style={{ textAlign: "center", justifyContent: "center", fontSize: 16, fontWeight: 500 }} onClick={() => setDateData(!dateData)}>{currentDate}
                <ThemeProvider theme={materialTheme}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      autoOk={true}
                      disablePast={true}
                      open={dateData}
                      variant="inline"
                      inputVariant="outlined"
                      label=""
                      format="MM/dd/yyyy"
                      InputProps={{
                        disableUnderline: true,
                        classes: props.classes
                      }}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                      style={{ visibility: 'hidden', width: 0 }}
                      value={moment(currentDate)}
                      InputAdornmentProps={{ shrink: true, position: "end" }}
                      onChange={(date) => changeDateData(date)}
                    />
                  </MuiPickersUtilsProvider>
                </ThemeProvider>
              </span>
              <Icon style={{ marginLeft: "10px", paddingTop: "2px", marginRight: "10px", textAlign: "center", justifyContent: "center" }} className="fa fa-chevron-right" color="primary" />
              <span style={{ marginLeft: "10px" }}>
                <label htmlFor="exportAll" style={{marginRight:4}} className="p-checkbox-label">
                  All
                </label>
                <Checkbox
                  value={exportAll}
                  onChange={() => setExportAll(!exportAll)}
                  checked={exportAll}
                  style={{marginRight:20, borderColor:'white'}}
                ></Checkbox>
               
                <Button
                  variant="contained"
                  size="large"
                  style={{
                    justifyContent: "center",
                    color: "white",
                    backgroundColor: "#33a6db",
                    fontSize: 8,
                    fontWeight: 600,
                  
                  }}
                  // disabled={!isFound}
                  onClick={() => onClickExportAll(dashboardData)}
                >
                  Export
                </Button>
              </span>
              <div className="table-wrapper-main d-flex flex-wrap row" style={{padding:'20px'}}>
                {
                  dashboardData && dashboardData.map((department, idx) => {
                    if (department.providers && department.providers.length == 0) {
                      return null
                    } else {
                      return (
                        <Grid item xs={3} key={"department"+idx.toString()}>
                          <div style={{ paddingRight: '10px', paddingLeft: '10px' }}>
                            <table className="table">
                              <thead className="thead-dark">
                                <tr>
                                  <th scope="col" colSpan="3">
                                    <Checkbox
                                      value={department.departmentCode}
                                      onChange={() => handleCardCheckChange(department.departmentCode)}
                                      checked={selectedExportCards.includes(department.departmentCode)}
                                      style={{marginRight:4}}
                                    ></Checkbox>
                                    {department.departmentName}
                                    <span className="heade-dots" onClick={() => exportCard(department)}>
                                      <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M13.4062 6.5625L11.7188 4.85156C11.5312 4.6875 11.25 4.80469 11.25 5.0625V6.21094H9V3.09375C9 2.8125 8.85938 2.50781 8.64844 2.29688L6.67969 0.351562C6.46875 0.140625 6.1875 0 5.90625 0H1.10156C0.492188 0.0234375 0 0.515625 0 1.14844V10.8984C0 11.5078 0.492188 12 1.10156 12H7.85156C8.48438 12 9 11.5078 9 10.8984V8.46094H7.875V10.8984H1.10156V1.14844H4.85156V3.58594C4.85156 3.89062 5.10938 4.14844 5.41406 4.14844H7.875V6.21094H4.03125C3.86719 6.21094 3.75 6.32812 3.75 6.49219V7.05469C3.75 7.19531 3.86719 7.33594 4.03125 7.33594H11.25V8.46094C11.25 8.71875 11.5312 8.83594 11.7188 8.67188L13.4062 6.98438C13.5234 6.86719 13.5234 6.67969 13.4062 6.5625ZM5.97656 3.02344V1.21875L7.78125 3.02344H5.97656Z" fill="#FFFFFF" />
                                      </svg>
                                    </span>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {
                                  department && department.providers.length != 0 ?
                                    <>
                                      {
                                        department && department.providers.map((provider, providerIdx) => {
                                          isFound = true
                                          return (<tr key={"provider" + providerIdx.toString()}>
                                            <td>{provider.teamName}</td>
                                            <td>{ provider.onCall ?
                                              <Icon style={{ color: green[500], justifyContent:"center", textAlign:"center", paddingTop:'1px' }} className="fa fa-phone" />
                                                  : ''
                                              }
                                              <span>{provider.providerName}</span>
                                            </td>
                                            <td>
                                              {
                                                provider.preferredCallNumber && <span className="calendar">
                                                  <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M2.05875 0.47081C2.01596 0.515919 1.94367 0.610138 1.89535 0.674891C0.997203 1.84953 -0.0761482 3.65532 0.00426097 5.39818C0.140735 8.31641 4.1339 12.195 5.35479 13.3144C6.57605 14.4333 10.7898 18.078 13.748 17.9987C14.2411 17.9867 14.7638 17.8845 15.3008 17.6946C16.5405 17.2563 17.6596 16.4225 18.3704 15.8088C18.3704 15.8088 18.5234 15.6804 18.5825 15.6185C18.7311 15.4603 18.8488 15.2293 18.9421 14.9124C18.9897 14.7506 19 14.5799 19 14.4657C19 14.3384 18.9871 14.0917 18.9023 13.8673C18.7861 13.5603 18.6529 13.3405 18.4936 13.1929C18.3755 13.0848 15.7084 11.024 15.6914 11.0124L15.6711 10.9993C15.5265 10.8898 15.3757 10.8043 15.2222 10.745C14.8202 10.5897 14.375 10.5835 13.9682 10.7268C13.7096 10.8181 13.4768 10.9691 13.2972 11.1604L12.3806 12.1281C12.2947 12.219 12.135 12.3132 12.0785 12.3267C12.0192 12.3376 11.9778 12.3405 11.9513 12.3413L5.79962 6.70305C5.78487 6.68923 5.77749 6.67577 5.77343 6.66631C5.77638 6.65758 5.78007 6.64994 5.78192 6.64412C5.80442 6.59901 5.91064 6.45569 6.04343 6.31381L6.95043 5.34544C7.4303 4.83651 7.54944 4.04493 7.24403 3.4276C7.13522 3.20751 6.98621 3.04308 6.91723 2.9656L6.88146 2.92195C6.86375 2.90194 4.6182 0.471537 4.5175 0.38023C4.26779 0.151413 3.8746 0.0277271 3.31579 0.00153542C3.00522 -0.0130157 2.61571 0.0772018 2.38961 0.215801C2.24428 0.305655 2.13547 0.389324 2.05875 0.47081ZM3.75288 1.17035C3.87865 1.29622 5.92245 3.50399 6.02941 3.61967L6.10466 3.70953C6.13527 3.74336 6.2072 3.82302 6.24925 3.90742C6.35843 4.1286 6.31564 4.41671 6.13859 4.60478L5.23049 5.57425C5.12426 5.68739 4.86606 5.97695 4.76352 6.21814C4.69565 6.37893 4.66356 6.51898 4.6632 6.68159C4.67426 6.99226 4.80779 7.28183 5.04311 7.50046L11.2567 13.1954C11.4932 13.4118 11.8369 13.481 12.2788 13.4006C12.6204 13.3384 12.9903 13.0837 13.1895 12.8735L14.1076 11.904C14.1688 11.8389 14.25 11.7872 14.3414 11.7545C14.4941 11.7006 14.6682 11.7032 14.8187 11.7614C14.9065 11.7952 14.9795 11.8516 15.0035 11.8702C15.0264 11.8876 15.0448 11.9004 15.0614 11.9105C15.317 12.1059 17.6105 13.8837 17.7348 13.987C17.7352 13.9877 17.7894 14.0477 17.8658 14.2489C17.8765 14.2773 17.8935 14.3609 17.8935 14.4653C17.8935 14.5407 17.885 14.5898 17.8794 14.6076C17.8219 14.8026 17.7743 14.871 17.7743 14.8724C17.7385 14.9077 17.664 14.9685 17.6515 14.979C17.0027 15.5389 16.0038 16.2864 14.9272 16.6669C14.5015 16.8175 14.0958 16.8983 13.7196 16.9074C11.6986 16.9616 8.35612 14.5745 6.10835 12.5144C3.86021 10.4547 1.20265 7.34112 1.1097 5.34798C1.04183 3.91106 1.98941 2.36464 2.76952 1.34388L2.7994 1.30459C2.81674 1.28131 2.84809 1.23765 2.86432 1.21874C2.89198 1.19291 2.93329 1.16781 2.96612 1.14744C3.01518 1.1227 3.16751 1.08778 3.26268 1.09251C3.58948 1.10815 3.7407 1.16599 3.75288 1.17035Z" fill="#1B84C6" />
                                                  </svg>
                                                </span>
                                              }
                                              {provider.preferredCallNumber ? provider.preferredCallNumber : 'N/A'}
                                            </td>
                                          </tr>)
                                        })
                                      }
                                    </>
                                    : <tr>
                                      <td className="text-center" colSpan="3">
                                        There is no team found
                                      </td>
                                    </tr>
                                }
                                {/* <tr>
                                  <td className="text-center" colSpan="3">
                                    <a href="#" className="view-link">View All</a>
                                  </td>
                                </tr> */}
                              </tbody>
                            </table>
                          </div>
                        </Grid>
                      )
                    }
                  })
                }

              </div>
            </div>
          </Grid>
          {
            !isFound && <Container maxWidth="lg" style={{ height: 400 }}>
              <div style={{ marginTop: 100, fontSize:16, textAlign:"center" }}>
                There is no providers found into the teams<strong> on selected date!</strong>
              </div>
            </Container>
          }
        </Grid>
      </div>
    </Fragment>
  );
}

export default GenericDashboard